import { createPassword, formatDate, getTimeDay } from './link-share-util'
import authDataMethods from './auth-data'
import createPreconditionMethods from './create-precondition'
// r下载
// w上传
// p预览

function RemixCreatePreconditionMethods(type, authDataParams, createParams) {
  // 原子权限与外链创建先决条件过滤后的数据,进行整合的方法
  const linkTime = new Date()
  const data = linkTime.getDate()+3
  linkTime.setDate(data)
  // 初始化的数据
  const newLinkParams = {
    LINK_ID: false, // 外链生成ID,初始化
    LINK_ID_VALUE: null, // 外链生成ID,数值,初始化
    DELIVERY_ID: false, // 外链CODE,初始化
    DELIVERY_ID_VALUE: null, // 外链CODE,数值,初始化
    URL: false, // 外链URL,初始化
    URL_VALUE: '', // 外链URL,数值,初始化,
    CREATOR_REMARK: false, // 备注名,初始化
    CREATOR_REMARK_VALUE: `${formatDate(new Date(), 'yyyy-MM-dd hh:mm')}新建的安全连接`, // 备注名,数值,初始化
    PREVIEW: true, // 预览,初始化
    PREVIEW_DISABLE: false, // 预览,禁用,初始化
    DOWNLOAD: true, // 下载,初始化
    DOWNLOAD_DISABLE: false, // 下载,禁用,初始化
    UPLOAD_SHOW: false, // 上传显隐,初始化
    UPLOAD: true, // 上传,初始化
    UPLOAD_DISABLE: false, // 上传,禁用,初始化
    IS_CHANGE_EOD: false, // 是否有强制本地管控选项,初始化
    IS_APPROVAL: true, // 审批,初始化
    IS_SNAPSHOT: false, // 文件快照,初始化
    IS_SNAPSHOT_DISABLE: false, // 文件快照,禁用,初始化
    IS_LOGIN_VERIFY: false, // 登录认证,初始化
    IS_LOGIN_VERIFY_DISABLE: false, // 登录认证,禁用,初始化
    IS_PROTECTED: true, // 提取安全码,初始化
    IS_PROTECTED_DISABLE: true, // 提取安全码,禁用,初始化
    IS_PROTECTED_VALUE: createPassword(4), // 提取安全码,数值,初始化
    MAX_EXPIRATION: true, // 添加链接有效期,初始化
    MAX_EXPIRATION_DISABLE: true, // 添加链接有效期,禁用,初始化
    MAX_EXPIRATION_VALUE: new Date(formatDate(new Date(), 'yyyy/MM/dd')), // 添加链接有效期,数值,初始化
    MAX_EXPIRATION_VALUE_DISABLE: false, // 添加链接有效期,数值禁用,初始化
    LIMIT_MAX_EXPIRATION_VALUE: '', // 添加链接有效期,限制,数值,初始化
    MAX_DOWNLOAD_COUNT_SHOW: false, // 限制下载次数显隐,初始化
    MAX_DOWNLOAD_COUNT: true, // 限制下载次数,初始化
    MAX_DOWNLOAD_COUNT_DISABLE: true, // 限制下载次数,禁用,初始化
    REMAIN_DOWNLOAD: false, // 限制下载次数的剩余次数,初始化
    INFO_REMAIN_DOWNLOAD_VALUE: '', // 限制下载次数的剩余次数,数值,初始化
    MAX_DOWNLOAD_COUNT_VALUE: '1', // 限制下载次数,数值,初始化
    LIMIT_MAX_DOWNLOAD_COUNT_VALUE: '', // 限制下载次数,限制,数值,初始化
    EOD_CONTROL: createParams.EOD_CONTROL,
    EOD_ID: false, // 本地管控,初始化
    EOD_ID_DISABLE: false, // 本地管控,禁用,初始化
    EOD_ID_VALUE: '', // 本地管控ID,数值,初始化
    DP_ID: false, // 本地管控策略ID,初始化
    DP_ID_VALUE: -1, // 本地管控策略ID,数值,初始化
    EOD_PASSWORD: false, // 添加本地密码,初始化
    EOD_PASSWORD_DISABLE: false, // 添加本地密码,禁用,初始化
    EOD_PASSWORD_VALUE: createPassword(4), // 添加本地密码,数值,初始化
    EOD_MAX_EXPIRATION: false, // 添加阅读有效期,初始化
    EOD_MAX_EXPIRATION_DISABLE: false, // 添加阅读有效期,禁用,初始化
    EOD_MAX_EXPIRATION_VALUE: new Date(formatDate(new Date(), 'yyyy/MM/dd')), // 添加阅读有效期,数值,初始化
    EOD_READ_START_TIME: new Date(formatDate(new Date(), 'yyyy/MM/dd')), // 添加阅读有效期,开始时间,初始化
    EOD_READ_END_TIME: new Date(formatDate(new Date(), 'yyyy/MM/dd')), // 添加阅读有效期,结束时间,初始化
    LIMIT_EOD_MAX_EXPIRATION_VALUE: '', // 添加阅读有效期,限制,数值,初始化
    MAX_READ_TIMES: false, // 限制阅读次数,初始化
    MAX_READ_TIMES_DISABLE: false, // 限制阅读次数,禁用,初始化
    MAX_READ_TIMES_VALUE: '', // 限制阅读次数,数值,初始化
    LIMIT_MAX_READ_TIMES_VALUE: '', // 限制阅读次数,限制,数值,初始化
    MAX_READ_DURATION: false, // 限制阅读时长,初始化
    MAX_READ_DURATION_DISABLE: false, // 限制阅读时长,禁用,初始化
    MAX_READ_DURATION_VALUE: '', // 限制阅读时长,数值,初始化
    LIMIT_MAX_READ_DURATION_VALUE: '', // 限制阅读时长,限制,数值,初始化
    IS_PRINT: false, // 允许打印,初始化
    IS_PRINT_DISABLE: false, // 允许打印,禁用,初始化
    IS_READ_ONLY: false, // 文档只读,初始化
    IS_READ_ONLY_DISABLE: false, // 文档只读,禁用,初始化
    IS_EXPIRED_DELETE: false, // 失效后删除,初始化
    IS_EXPIRED_DELETE_DISABLE: false, // 失效后删除,禁用,初始化
    WATERMARK_CONTENT: false, // 添加水印,初始化
    WATERMARK_CONTENT_DISABLE: false, // 添加水印,禁用,初始化
    WATERMARK_CONTENT_VALUE: '', // 添加水印,数值,初始化
    LIMIT_WATERMARK_CONTENT: false, // 先决条件接口,添加水印,初始化
    LIMIT_WATERMARK_CONTENT_VALUE: '', // 先决条件接口,添加水印,数值,初始化
    INFO_IS_CHECKED_WATERMARK: false, // INFO接口,添加水印,打勾,初始化
    INFO_WATERMARK_CONTENT_VALUE: '', // INFO接口,添加水印,数值,初始化
    WATERMARK_CONTENT_VALUE_SHOW: false, // 添加水印输入框是否显示,初始化
    DESCRIPTION: false, // 说明,初始化
    DESCRIPTION_VALUE: '', // 说明,数值,初始化
    IS_APPROVE_POLICY_UPLOAD: createParams.IS_APPROVE_POLICY_UPLOAD, // 是否存在上传审批
    SIZE: createParams.SIZE,
  }
  // 预览参数算法
  if (authDataParams.PREVIEW === false
  || createParams.PREVIEW === false
  || type.canPreview === false) {
    // 如果原子权限为false 或 外链先决条件为false 或 文件类型为不可预览,那么外链一定是不可预览的,取消打勾并且禁用
    newLinkParams.PREVIEW = false
    newLinkParams.PREVIEW_DISABLE = true
  }
  // 下载参数算法
  if (authDataParams.DOWNLOAD === false || createParams.DOWNLOAD === false) {
    // 如果原子权限为false 或 外链先决条件为false ,那么外链一定是不可下载的,取消打勾并且禁用
    newLinkParams.DOWNLOAD = false
    newLinkParams.DOWNLOAD_DISABLE = true
  }
  // 上传显隐算法
  if (createParams.UPLOAD_SHOW === true) {
    newLinkParams.UPLOAD_SHOW = true
  } else {
    newLinkParams.UPLOAD_SHOW = false
  }
  // 上传参数算法
  if (authDataParams.UPLOAD === false
  || createParams.UPLOAD === false
  || type.canUpload === false) {
    // 如果原子权限为false 或 外链先决条件为false 或 文件类型为不可上传,那么外链一定是不可上传的,取消打勾并且禁用
    newLinkParams.UPLOAD = false
    newLinkParams.UPLOAD_DISABLE = true
  }
  // 外链选项是否受到强制本地管控
  if (createParams.IS_CHANGE_EOD === true) {
    newLinkParams.IS_CHANGE_EOD = true
  }
  // 审批开启算法
  if (createParams.IS_APPROVAL === true) {
    newLinkParams.IS_APPROVAL = true
  }
  // 文件快照算法
  if (createParams.IS_SNAPSHOT === true) {
    // 如果外链先决条件为true并且含有上传审批,那么外链一定是文件快照打勾且禁用的,并且上传一定会取消打勾并且禁用
    if (createParams.IS_APPROVE_POLICY_UPLOAD) {
      newLinkParams.IS_SNAPSHOT_DISABLE = true
      newLinkParams.UPLOAD_DISABLE = true
    }
    newLinkParams.IS_SNAPSHOT = true
    newLinkParams.UPLOAD = false
  }
  // 登录认证算法
  if (createParams.IS_LOGIN_VERIFY === true) {
    // 如果外链先决条件为true,那么外链一定是登录认证打勾且禁用的
    newLinkParams.IS_LOGIN_VERIFY = true
    newLinkParams.IS_LOGIN_VERIFY_DISABLE = true
  }
  // 添加提取码算法
  if (createParams.IS_PROTECTED === true) {
    // 如果外链先决条件为true,那么外链一定是登录认证打勾且禁用的
    newLinkParams.IS_PROTECTED = true
    newLinkParams.IS_PROTECTED_DISABLE = true
    newLinkParams.IS_PROTECTED_VALUE = createPassword(4)
  }
  // 添加链接有效期算法
  if (createParams.MAX_EXPIRATION === true) {
    // 如果外链先决条件为true,那么外链一定是添加链接有效期打勾且禁用的
    // 限制时间减去一天,原因是,由于没有时分秒,所以当天需要减去一天来表达是当天
    const limitTime = getTimeDay(createParams.MAX_EXPIRATION_VALUE - 1)
    const limitTimeMaxDay = new Date(new Date(formatDate(new Date(), 'yyyy/MM/dd')).getTime() + limitTime)
    newLinkParams.MAX_EXPIRATION = true
    newLinkParams.MAX_EXPIRATION_DISABLE = true
    newLinkParams.MAX_EXPIRATION_VALUE = limitTimeMaxDay
    newLinkParams.LIMIT_MAX_EXPIRATION_VALUE = createParams.MAX_EXPIRATION_VALUE
  }
  // 限制下载次数显隐算法
  if (createParams.MAX_DOWNLOAD_COUNT_SHOW === true) {
    // 如果此参数为true,那么展示限制下载次数
    newLinkParams.MAX_DOWNLOAD_COUNT_SHOW = true
  } else {
    newLinkParams.MAX_DOWNLOAD_COUNT_SHOW = false
  }
  // 限制下载次数算法
  if (createParams.MAX_DOWNLOAD_COUNT === true) {
    // 如果外链先决条件为true,那么外链一定是限制下载次数打勾且禁用的
    newLinkParams.MAX_DOWNLOAD_COUNT = true
    newLinkParams.MAX_DOWNLOAD_COUNT_DISABLE = true
    newLinkParams.MAX_DOWNLOAD_COUNT_VALUE = ''
    newLinkParams.LIMIT_MAX_DOWNLOAD_COUNT_VALUE = createParams.MAX_DOWNLOAD_COUNT_VALUE
  }
  // 开启本地管控算法
  if (createParams.EOD_ID === true) {
    // 如果外链先决条件为true,那么外链一定是开启本地管控打勾且禁用的
    newLinkParams.EOD_ID = true
    newLinkParams.EOD_ID_DISABLE = true
    newLinkParams.EOD_ID_VALUE = createParams.EOD_ID_VALUE
  }
  // 本地管控策略ID算法
  if (createParams.DP_ID === true) {
    // 如果外链先决条件为true,那么外链一定是开启本地管控打勾且禁用的
    newLinkParams.DP_ID = true
    newLinkParams.DP_ID_VALUE = createParams.DP_ID_VALUE
  }
  // 添加本地密码算法
  if (createParams.EOD_PASSWORD === true) {
    // 如果外链先决条件为true,那么外链一定是添加本地密码打勾且禁用的
    newLinkParams.EOD_PASSWORD = true
    newLinkParams.EOD_PASSWORD_DISABLE = true
    newLinkParams.EOD_PASSWORD_VALUE = createPassword(4)
  }
  // 添加阅读有效期算法
  if (createParams.EOD_MAX_EXPIRATION === true) {
    // 如果外链先决条件为true,那么外链一定是添加阅读有效期打勾且禁用的
    newLinkParams.EOD_MAX_EXPIRATION = true
    newLinkParams.EOD_MAX_EXPIRATION_DISABLE = true
    newLinkParams.EOD_MAX_EXPIRATION_VALUE = new Date(formatDate(new Date(), 'yyyy/MM/dd')).getTime()
    newLinkParams.LIMIT_EOD_MAX_EXPIRATION_VALUE = createParams.EOD_MAX_EXPIRATION_VALUE
  }
  // 限制阅读次数算法
  if (createParams.MAX_READ_TIMES === true) {
    // 如果外链先决条件为true,那么外链一定是限制阅读次数打勾且禁用的
    newLinkParams.MAX_READ_TIMES = true
    newLinkParams.MAX_READ_TIMES_DISABLE = true
    newLinkParams.MAX_READ_TIMES_VALUE = ''
    newLinkParams.LIMIT_MAX_READ_TIMES_VALUE = createParams.MAX_READ_TIMES_VALUE
  }
  // 限制阅读时长算法
  if (createParams.MAX_READ_DURATION === true) {
    // 如果外链先决条件为true,那么外链一定是限制阅读时长打勾且禁用的
    newLinkParams.MAX_READ_DURATION = true
    newLinkParams.MAX_READ_DURATION_DISABLE = true
    newLinkParams.MAX_READ_DURATION_VALUE = ''
    newLinkParams.LIMIT_MAX_READ_DURATION_VALUE = createParams.MAX_READ_DURATION_VALUE
  }
  // 允许打印算法
  if (createParams.IS_PRINT === true) {
    // 如果外链先决条件为true,那么外链一定是允许打印不打勾且禁用的
    newLinkParams.IS_PRINT = false
    newLinkParams.IS_PRINT_DISABLE = true
  }
  // 文档只读算法
  if (createParams.IS_READ_ONLY === true) {
    // 如果外链先决条件为true,那么外链一定是文档只读打勾且禁用的
    newLinkParams.IS_READ_ONLY = true
    newLinkParams.IS_READ_ONLY_DISABLE = true
  }
  // 失效后删除算法
  if (createParams.IS_EXPIRED_DELETE === true) {
    // 如果外链先决条件为true,那么外链一定是失效后删除打勾且禁用的
    newLinkParams.IS_EXPIRED_DELETE = true
    newLinkParams.IS_EXPIRED_DELETE_DISABLE = true
  }
  // 添加水印算法
  if (createParams.LIMIT_WATERMARK_CONTENT === true) {
    // 如果外链先决条件为true,那么外链一定是添加水印打勾且禁用的,并且有水印内容
    newLinkParams.LIMIT_WATERMARK_CONTENT = true
    newLinkParams.LIMIT_WATERMARK_CONTENT_VALUE = createParams.LIMIT_WATERMARK_CONTENT_VALUE
  }
  return newLinkParams
}

export default function deleveryRemixCreatePrecondition(type, authParams, createParams) {
  const authData = authDataMethods(authParams)
  const createPreconditionData = createPreconditionMethods(createParams)
  return RemixCreatePreconditionMethods(type, authData, createPreconditionData)
}
